import React, { memo } from 'react';
import SkeletonText from '../../../../../../../../../shared/components/SkeletonText';
const styled = { padding: "4px 0", flex: "0.33", minWidth: "33%" };

const CustomSkeleton = ({ options = [1, 2, 3] }) =>
    options.map((option) =>
        <div key={option} style={styled}>
            <SkeletonText key={option} height={'12px'} />
        </div>
    )

export default memo(CustomSkeleton);
